import { render, staticRenderFns } from "./tip-modal.vue?vue&type=template&id=5ab29ddd&scoped=true&lang=pug&"
import script from "./tip-modal.vue?vue&type=script&lang=js&"
export * from "./tip-modal.vue?vue&type=script&lang=js&"
import style0 from "./tip-modal.vue?vue&type=style&index=0&id=5ab29ddd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab29ddd",
  null
  
)

export default component.exports